<template>
    <div class="row product-card">
    <div class="col" v-if="!isInEdit && product">
        <div class="row">
            <div class="col">
                <div class="d-flex product-card-actions align-items-center justify-content-between">
                    <router-link class="btn btn-back btn-lg" :to="`/settings/print-machine-products/${pmId}`" tag="button">
                        <i class="ico ico-close"></i>
                    </router-link>
                    <h2 class="ml-4">{{product.name}}</h2>
                    <div class="d-flex">
                        <button type="button" class="ml-4 btn btn-outline-secondary" @click="deleteProduct"><i class="ico ico-delete"></i></button>
                        <button type="button" class="ml-2 btn btn-outline-secondary"  @click="editProduct"><i class="ico ico-pencil"></i></button>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mt-4">
             <div class="col print-machine-properties">
                <div>
                    <span class="print-machine-property-name">Статус:</span>
                    <div class="print-machine-property-pill" :class="{'print-machine-property-pill-disabled': !product.enabled}">
                        <span v-if="product.enabled">включен</span>
                        <span v-else>отключен</span>
                    </div>
                </div>
                 <div>
                    <span class="print-machine-property-name">Коэффициент:</span><span class="print-machine-property-value">{{ product.multiplier }}</span>
                </div>
                 <div>
                    <span class="print-machine-property-name">Описание:</span><span class="print-machine-property-value">{{ product.description }}</span>
                </div>
                <router-link class="btn btn-outline-secondary mt-2 w-100" :to="`/settings/print-machine-products/${printMachineId}/product-card/${productId}/settings`" tag="button">
                    <i class="ico ico-product mr-2"></i>настройки содержания продуктов
                </router-link>
             </div>
         </div>
    </div>
     <div class="col" v-else>
        <div class="row">
            <div class="col">
                <div class="d-flex print-machine-card-actions align-items-center justify-content-between">
                    <input type="text" placeholder="Название продукта" class="form-control form-control-lg" v-model="productForEdit.name">
                    <div class="d-flex">
                        <button type="button" class="btn btn-secondary ml-2" @click="cancelEdit">{{ $t('home.cancel') }}</button>
                        <button type="button" class="btn btn-primary ml-2" @click="saveAfterEdit">{{ $t('home.save') }}</button>
                    </div>
                </div>
            </div>
        </div>
         <div class="row mt-4">
             <div class="col print-machine-properties">
                <div>
                    <span class="print-machine-property-name">Статус:</span>
                    <div class="print-machine-property-pill" v-if="productForEdit.enabled">
                        <span>включен</span>
                    </div>
                    <span class="cursor-pointer" v-else @click="productForEdit.enabled = true">включен</span>
                     <div class="print-machine-property-pill print-machine-property-pill-disabled"  v-if="!productForEdit.enabled">
                        <span>отключен</span>
                    </div>
                    <span class="cursor-pointer" v-else @click="productForEdit.enabled = false">отключен</span>
                </div>
                <div class="form-inline mt-1">
                  <span class="print-machine-property-name">Коэффициент:</span>
                  <input type="text" class="form-control" id="multiplier" v-model="productForEdit.multiplier" @blur="()=> productForEdit.multiplier = productForEdit.multiplier.replace(',', '.')">
                </div>
                <div class="form-inline mt-1">
                  <span class="print-machine-property-name">Описание:</span>
                  <textarea class="form-control" rows="5"  v-model="productForEdit.description"/>
                </div>
             </div>
         </div>
      </div>
  </div>
</template>

<script>
import api from '../../../api'

const defaultProduct = () => {
  return {
    id: null,
    name: '',
    enabled: true,
    multiplier: 1,
    description: ''
  }
}

export default {
  name: 'ProductCard',
  props: {
    printMachineId: {
      default: null
    },
    productId: {
      default: null
    }
  },
  data: () => {
    return {
      product: null,
      isInEdit: false,
      productForEdit: defaultProduct(),
      algorithms: null
    }
  },
  methods: {
    loadPrintMachineProduct (prId) {
      api.get.printMachineProducts(this.pmId).then(resp => {
        this.product = resp.data.data.products.find(x => x.id === prId)
      })
    },
    closeCard () {
      this.$router.push({
        path: `/settings/print-machine-products/${this.pmId}`
      })
    },
    editProduct () {
      if (this.prId) {
        this.productForEdit = Object.assign({}, this.product)
      } else {
        this.productForEdit = defaultProduct()
      }
      this.isInEdit = true
    },
    cancelEdit () {
      if (!this.prId) {
        this.closeCard()
      }
      this.isInEdit = false
    },
    deleteProduct () {
      this.$modal.show('dialog', {
        title: 'Внимание!',
        text: 'Вы уверены что хотите удалить?',
        buttons: [
          {
            title: 'Нет'
          },
          {
            title: 'Да',
            default: true,
            handler: () => {
              api.get
                .deletePrintMachineProduct(this.pmId, this.prId)
                .then(() => {
                  this.$eventBus.$emit('updatePrintMachineProducts')
                  this.$modal.hide('dialog')
                  this.closeCard()
                })
            }
          }
        ]
      })
    },
    saveAfterEdit () {
      if (this.prId) {
        api.post
          .updatePrintMachineProduct(this.pmId, this.productForEdit)
          .then(resp => {
            this.loadPrintMachineProduct(resp.data.data.product.id)
            this.$eventBus.$emit('updatePrintMachineProducts')
            this.cancelEdit()
          })
          .catch(() => {
            this.cancelEdit()
          })
      } else {
        api.post
          .createPrintMachineProduct(this.pmId, this.productForEdit)
          .then(resp => {
            this.$eventBus.$emit('updatePrintMachineProducts')
            this.$router.push({
              path: `/settings/print-machine-products/${
                this.pmId
              }/product-card/${resp.data.data.product.id}`
            })
          })
          .catch(() => {
            this.cancelEdit()
          })
      }
    }
  },
  watch: {
    productId: function (val) {
      if (+val) {
        this.isInEdit = false
        this.loadPrintMachineProduct(+val)
      } else {
        this.editProduct()
      }
    }
  },
  computed: {
    pmId () {
      return +this.printMachineId
    },
    prId () {
      return +this.productId
    }
  },
  created () {
    if (this.prId) {
      this.isInEdit = false
      this.loadPrintMachineProduct(this.prId)
    } else {
      this.editProduct()
    }
  }
}
</script>

<style>
</style>
